import { createAuthStore } from '@react-apps/auth';
import type { StoredAuth } from '../../domain/entities/auth.entity';

/**
 * Store de identidade deste app — a fábrica é compartilhada
 * (`@react-apps/auth`), o formato do snapshot é daqui: inclui `roles`, as perk
 * keys que dirigem o `RoleGuard` e a sidebar.
 */
export const useAuthStore = createAuthStore<StoredAuth>();
